/* eslint-disable */
import * as context from 'api/base';
import HeaderWidget from './HeaderWidget';
import ProductCardsWidget from './ProductCardsWidget';
import ProductDetailedCardWidget from './ProductDetailedCardWidget';
import ProductOptionCardsWidget from './ProductOptionCardsWidget';
import ContactDetailsFromCompanyDetailsWidget from './ContactDetailsFromCompanyDetailsWidget';
import ContactFormFromCompanyDetailsWidget from './ContactFormFromCompanyDetailsWidget';
import TCDetailsFromCompanyDetailsWidget from './TCDetailsFromCompanyDetailsWidget';
import DisclosureDetailsFromCompanyDetailsWidget from './DisclosureDetailsFromCompanyDetailsWidget';
import { getPage, widgetsEnum } from './Helpers/WidgetHelper';

export function WidgetFactory(page, productId, productOptionId) {
	let i = 0;

	const widgetContainer = [];
	const pageWidgets = getPage(page, productId);

	Array.prototype.forEach.call(pageWidgets.content, element => {
		switch (element.widget) {
			case 'ProductCardsWidget':
				const prods = context.getProducts();
				widgetContainer.push(<ProductCardsWidget key={i++} products={prods} />);
				break;
			case 'ProductDetailedCardWidget':
				widgetContainer.push(
					<ProductDetailedCardWidget
						key={i++}
						descriptionType={element.type}
						columnType={element.columnType}
						productInstanceId={productId}
						columns={element.columns}
					/>
				);
				break;
			case 'ProductOptionCardsWidget':
				widgetContainer.push(
					<ProductOptionCardsWidget
						key={i++}
						descriptionType={element.type}
						columnType={element.columnType}
						productInstanceId={productId}
						productOptionId={productOptionId}
						columns={element.columns}
					/>
				);
				break;
			case 'header':
				widgetContainer.push(
					<HeaderWidget key={i++} headingTag={element.description} mainTitle={element.content} />
				);
				break;
			case 'paragraph':
				widgetContainer.push(
					<HeaderWidget key={i++} headingTag={element.description} mainTitle={element.content} />
				);
				break;
			case 'home':
				widgetContainer.push(
					<HeaderWidget key={i++} headingTag={element.description} mainTitle={element.content} />
				);
				break;
			case widgetsEnum['CONTACT-FORM-FROM-COMPANY-DETAILS']:
				widgetContainer.push(
					<ContactFormFromCompanyDetailsWidget key={i++} token={element.type} columns={element.columns} />
				);
				break;
			case widgetsEnum['CONTACT-DETAILS-FROM-COMPANY-DETAILS']:
				widgetContainer.push(
					<ContactDetailsFromCompanyDetailsWidget key={i++} token={element.type} columns={element.columns} />
				);
				break;
			case widgetsEnum['TC-DETAILS-FROM-COMPANY-DETAILS']:
				widgetContainer.push(<TCDetailsFromCompanyDetailsWidget key={i++} token={element.type} />);
				break;
			case widgetsEnum['DISCLOSURE-DETAILS-FROM-COMPANY-DETAILS']:
				widgetContainer.push(<DisclosureDetailsFromCompanyDetailsWidget key={i++} token={element.type} />);
				break;
			default:
				break;
		}
	});

	return widgetContainer;
}
